/*
 * Panel tipo tarjeta del dashboard, con la tipografía y espaciado del proyecto
 */
import { Box, Description, Title } from "codekit";

/**
 * Renderiza un panel con encabezado y contenido
 * @param {Object} props Propiedades del componente
 * @param {string} props.title Título del panel
 * @param {string} props.hint Descripción o ayuda bajo el título
 * @param {React.ReactNode} props.children Contenido del panel
 */
const Panelbox = ({ title, hint, children }) => (
  <Box bg="neutral-100" rounded="lg" border={1} borderColor="neutral-300" spacing={6} mb={6}>
    <Title variant="title-2" color="accent-600">
      {title}
    </Title>
    {hint ? (
      <Box mt={1} mb={5}>
        <Description variant="description-3" color="neutral-500">
          {hint}
        </Description>
      </Box>
    ) : (
      <Box mb={4} />
    )}
    {children}
  </Box>
);

export default Panelbox;
